import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Button } from '../shared/Button';
import { ArrowLeftIcon } from 'lucide-react';
export const OnboardingPage = () => {
  return <div className="w-full min-h-screen bg-gradient-to-b from-[#231232] to-[#1a0d24] flex flex-col" data-id="element-42" data-mp="339zt3j8m3uz1">
      <Helmet data-id="element-43" data-mp="37b1ht64wkomr">
        <title data-id="element-44" data-mp="37ajpgkld2uk4">Schedule Your Onboarding Session</title>
        <meta name="description" content="Schedule your onboarding session with our team" data-id="element-45" data-mp="37de949wjwbch" />
      </Helmet>
      {/* Header */}
      <header className="w-full py-6 px-4 sm:px-6 lg:px-8 border-b border-[#6805DA]/20" data-id="element-46" data-mp="2yboih6ahtgfr">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-47" data-mp="2jmiaastogfvq">
          <Button variant="ghost" href="/" className="text-white/80 hover:text-white flex items-center gap-2" data-id="element-48" data-mp="2okk4a8sn5zlz">
            <ArrowLeftIcon size={18} data-id="element-49" data-mp="2alu6eqxzzvwk" />
            <span data-id="element-50" data-mp="2fjvr1gb2o3a5">Back to Home</span>
          </Button>
        </div>
      </header>
      {/* Main Content */}
      <main className="flex-1 py-12 px-4 sm:px-6 lg:px-8 flex flex-col items-center" data-id="element-51" data-mp="27jf126zwp8mc">
        <div className="max-w-4xl w-full mx-auto text-center mb-10" data-id="element-52" data-mp="23imrtdr1b3q2">
          <h1 className="text-3xl sm:text-4xl font-outfit font-bold mb-6 text-white" data-id="element-53" data-mp="23kfp42frcble">
            Schedule Your Onboarding Session
          </h1>
          <div className="h-1 w-24 bg-gradient-to-r from-[#FFC501] to-[#DF4425] mx-auto rounded-full mb-6" data-id="element-54" data-mp="2cij7ipvg4s8z"></div>
          <p className="text-lg text-white/80 max-w-2xl mx-auto" data-id="element-55" data-mp="1oui7k5cc2k56">
            Select a time that works best for you to meet with our team and
            begin your career transformation journey.
          </p>
          
        </div>
        {/* Zoom Scheduler Embed */}
        <div className="w-full max-w-4xl bg-white/5 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-xl border border-white/10" data-id="element-56" data-mp="1tstf29f5oik8">
          <div className="w-full max-w-[750px] h-[560px] mx-auto overflow-hidden rounded-xl" data-id="element-57" data-mp="161xikyzr8z6n">
            <iframe src="https://scheduler.zoom.us/beatrice-bock/onboarding?embed=true" frameBorder="0" style={{
            width: '750px',
            height: '560px'
          }} title="Zoom Scheduler" data-id="element-58" data-mp="112umw55o05bc"></iframe>
          </div>
          <div className="mt-8 text-center" data-id="element-59" data-mp="3ax8az4m3vjdx">
            <p className="text-white/60 text-sm" data-id="element-60" data-mp="3ayb2ner95puw">
              Having trouble with scheduling? Contact us at{' '}
              <a href="mailto:support@applypass.com" className="text-[#FFC501] hover:underline" data-id="element-61" data-mp="2i7j8emtqzba7">
                support@applypass.com
              </a> <br data-id="element-62" data-mp="2r7xuhoejcuer" />
              or <a target="_blank" href="https://scheduler.zoom.us/beatrice-bock/onboarding" className="text-[#FFC501] hover:underline" data-id="element-63" data-mp="2r7g1d0n66wb2">
              click here if you're on mobile</a>
            </p>
          </div>
        </div>
      </main>
    </div>;
};